export default {
  accessToken: localStorage.getItem("access_token"),
};
